import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  template: `
     <form [formGroup]="formEdit" >
     <mat-dialog-content>
       <div [hidden] = "type !== 'QR'">
        <qrcode [width]='256' [qrdata]='UID' [errorCorrectionLevel]="'M'"></qrcode>
       </div>
       <div [hidden] = "type === 'QR'">
        <ngx-barcode [bc-value]="UID" [bc-format]="type === 'QR' ? '' : type" [bc-display-value]="true"></ngx-barcode>
       </div>
     </mat-dialog-content>
    </form>
  `,
  styleUrls: ['./img-dialog.component.css']
})

export class ImgDialogComponent implements OnInit {
  formEdit: FormGroup;
  UID: string;
  type: string;
  constructor(private formBuilder: FormBuilder,
              private dialogRef: MatDialogRef<ImgDialogComponent>,
              @Inject(MAT_DIALOG_DATA) private data) {
                this.UID = data.UID;
                this.type = data.TYPE ;
   }

  ngOnInit(): void {
    this.formEdit = this.formBuilder.group({});
  }
}



